import RolesForm from 'components/Forms/Role/RolesForm'
import { ClientDataContext } from 'context/ClientDataContext'
import useQuery from 'hooks/useQuery'
import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Roles } from 'utils/enums'

const rolesToShow = [Roles.Account]

const AddAccount = () => {
  const navigate = useNavigate()

  const { fetchAccounts } = useContext(ClientDataContext)

  const { makeRequest } = useQuery({
    defaultEndpoint: '/register/accounts',
    defaultMethod: 'post',
    isControlled: true,
    toastOptions: {
      duration: 10,
      showFeedbackMessage: true,
      resultMessageError: { 403: 'Máximo número de cuentas alcanzado' },
      resultMessageSuccess: 'La cuenta ha sido creada',
    },
  })

  const [errorStatus, setErrorStatus] = useState(null)
  const [errorMessage, setErrorMessage] = useState(null)

  const onSubmitForm = async ({ values, setSubmitting }) => {
    setSubmitting(true)
    const registerResponse = await makeRequest({ body: values })
    setSubmitting(false)
    if (registerResponse.error) {
      setErrorStatus(registerResponse.status)
      setErrorMessage(registerResponse.message)
      return
    }
    await fetchAccounts()
    navigate('/clients/accounts')
  }

  return (
    <RolesForm
      onSubmitForm={onSubmitForm}
      error={errorStatus}
      errorMessage={errorMessage}
      rolesToShow={rolesToShow}
      title='Registrar Cuenta'
    />
  )
}

export default AddAccount
